var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTranchesCreatedActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.11237 22.7657C5.31698 22.765 4.55444 22.4485 3.99237 21.8857L0.882385 18.7357C0.602705 18.457 0.380786 18.1258 0.22937 17.7612C0.077954 17.3965 0 17.0056 0 16.6107C0 16.2159 0.077954 15.8249 0.22937 15.4603C0.380786 15.0956 0.602705 14.7644 0.882385 14.4857L5.0224 10.3457C5.59468 9.80271 6.3535 9.5 7.1424 9.5C7.93129 9.5 8.69011 9.80271 9.26239 10.3457L12.3724 13.4857C12.6521 13.7644 12.874 14.0956 13.0254 14.4603C13.1768 14.8249 13.2548 15.2159 13.2548 15.6107C13.2548 16.0056 13.1768 16.3965 13.0254 16.7612C12.874 17.1258 12.6521 17.457 12.3724 17.7357L8.23236 21.8657C7.9557 22.148 7.62603 22.3728 7.26221 22.5273C6.89839 22.6817 6.5076 22.7628 6.11237 22.7657ZM7.11237 11.4757C6.98076 11.475 6.85029 11.5002 6.72845 11.5499C6.60662 11.5997 6.49584 11.673 6.4024 11.7657L2.26239 15.9057C2.07614 16.0931 1.97162 16.3465 1.97162 16.6107C1.97162 16.8749 2.07614 17.1284 2.26239 17.3157L5.4024 20.4857C5.49537 20.5794 5.60592 20.6538 5.72778 20.7046C5.84964 20.7554 5.98035 20.7815 6.11237 20.7815C6.24438 20.7815 6.37509 20.7554 6.49695 20.7046C6.61881 20.6538 6.72942 20.5794 6.82239 20.4857L10.9524 16.3457C11.1386 16.1584 11.2432 15.9049 11.2432 15.6407C11.2432 15.3765 11.1386 15.1231 10.9524 14.9357L7.80237 11.7757C7.70893 11.683 7.59816 11.6097 7.47632 11.56C7.35448 11.5102 7.22401 11.485 7.09241 11.4857L7.11237 11.4757Z",
    fill: "url(#paint0_linear_3151_4929)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6125 13.2657C14.8172 13.265 14.0546 12.9485 13.4926 12.3857L10.3326 9.23572C10.0529 8.95701 9.83098 8.62583 9.67957 8.26118C9.52815 7.89652 9.4502 7.50556 9.4502 7.11072C9.4502 6.71588 9.52815 6.32492 9.67957 5.96027C9.83098 5.59561 10.0529 5.26443 10.3326 4.98572L14.4726 0.845722C15.0449 0.302714 15.8037 0 16.5926 0C17.3815 0 18.1403 0.302714 18.7126 0.845722L21.8826 4.00572C22.1622 4.28443 22.3842 4.61561 22.5356 4.98027C22.687 5.34492 22.765 5.73588 22.765 6.13072C22.765 6.52556 22.687 6.91652 22.5356 7.28118C22.3842 7.64583 22.1622 7.97701 21.8826 8.25572L17.7426 12.3857C17.4631 12.6656 17.131 12.8874 16.7654 13.0384C16.3999 13.1894 16.0081 13.2667 15.6125 13.2657ZM16.6125 1.97572C16.4809 1.97496 16.3505 2.00019 16.2286 2.04995C16.1068 2.09971 15.996 2.17304 15.9026 2.26572L11.7626 6.40572C11.5763 6.59308 11.4718 6.84654 11.4718 7.11072C11.4718 7.37491 11.5763 7.62836 11.7626 7.81572L14.8826 10.9757C14.9755 11.0695 15.0861 11.1438 15.208 11.1946C15.3299 11.2454 15.4606 11.2715 15.5926 11.2715C15.7246 11.2715 15.8553 11.2454 15.9772 11.1946C16.099 11.1438 16.2096 11.0695 16.3026 10.9757L20.4326 6.83572C20.6188 6.64836 20.7234 6.39491 20.7234 6.13072C20.7234 5.86654 20.6188 5.61308 20.4326 5.42572L17.2826 2.26572C17.0988 2.08338 16.8515 1.97943 16.5926 1.97572H16.6125Z",
    fill: "url(#paint1_linear_3151_4929)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4183 6.89032L6.4209 14.8877L7.83511 16.3019L15.8325 8.30453L14.4183 6.89032Z",
    fill: "url(#paint2_linear_3151_4929)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3151_4929",
    x1: 6.62738,
    y1: 23.994,
    x2: 6.62738,
    y2: 7.78037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2177,
    stopColor: "#5C2562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656429,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3151_4929",
    x1: 16.1076,
    y1: 14.494,
    x2: 16.1076,
    y2: -1.71963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2177,
    stopColor: "#5C2562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656429,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3151_4929",
    x1: 11.9647,
    y1: 12.4342,
    x2: 10.2363,
    y2: 10.7057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2177,
    stopColor: "#5C2562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656429,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranchesCreatedActive);
export default __webpack_public_path__ + "static/media/tranches-created-active.029ead0fec59c1fc7725e7d070db15f2.svg";
export { ForwardRef as ReactComponent };